import { plainCompoundVariants, plainDefaultVariants, plainDisabledVariants, plainEmphasisVariants, plainTextStyleVariants, plainTypeVariants, plainVariantSlots } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const plainButtonVariants = tv({
    slots: plainVariantSlots,
    variants: {
        type: plainTypeVariants,
        textStyle: plainTextStyleVariants,
        emphasis: plainEmphasisVariants,
        disabled: plainDisabledVariants,
        variant: {
            standalone: {},
            inline: {
                textSlot: 'underline'
            }
        }
    },
    compoundVariants: plainCompoundVariants,
    defaultVariants: {
        ...plainDefaultVariants,
        variant: 'standalone'
    }
});
const PlainButtonTypes = Object.keys(plainButtonVariants.variants.type);
export { PlainButtonTypes, plainButtonVariants };
